// extracted by mini-css-extract-plugin
module.exports = {"content":"style__content__1jIbY","videoRef":"style__videoRef__OIPNz","image":"style__image__13VsQ"};